import React, { useState } from 'react'
import { Modal, ModalBody, ModalFooter, Button, Input, Label } from 'reactstrap'
import { useStopSessionMutation } from './processApiSlice'
import { enqueueSnackbar } from 'notistack'
import { URL_SESSION_PROCESS } from 'utils/pathUrl'
import { useNavigate } from 'react-router-dom'
import { setSession } from './processSlice'
import { useDispatch } from 'react-redux'
import { setSessionProcess } from 'features/public-views/login/loginSlice'

const ModalEndSession = ({ isOpen, toggle }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [notes, setNotes] = useState()
  const [stoptSession, response] = useStopSessionMutation()

  const onConfirm = async () => {
    try {
      const res = await stoptSession({ note: notes })
      if (res?.error) {
        throw res
      }
      dispatch(setSessionProcess(null))
      enqueueSnackbar('Sesi selesai.', {
        variant: 'success',
      })
      navigate(URL_SESSION_PROCESS)
      toggle()
    } catch (error) {
      enqueueSnackbar(error?.message ?? error?.error?.data?.message, {
        variant: 'error',
      })
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered data-testid="process-end-session-modal">
      <ModalBody>
        <h6 className="fw-semibold">Akhiri Sesi</h6>
        <Label className="my-1" for="sessionNotes">
          Catatan Sesi (Opsional)
        </Label>
        <Input
          id="sessionNotes"
          type="textarea"
          rows="3"
          placeholder="Tambahkan catatan tentang sesi ini..."
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          className="mb-3"
          data-testid="process-end-session-notes"
        />

        <p className="text-muted small mb-0">
          Tindakan ini akan mengakhiri sesi produksi saat ini. Semua proses yang
          sudah tercatat akan disimpan.
        </p>
      </ModalBody>

      <ModalFooter className="border-0">
        <Button
          className="btn-cancel"
          color="secondary"
          onClick={toggle}
          data-testid="process-end-session-cancel-button"
        >
          Batal
        </Button>
        <Button
          color="danger"
          onClick={onConfirm}
          data-testid="process-end-session-submit-button"
        >
          Akhiri Sesi
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ModalEndSession
